<hr />
<div class="row mt-5">
  <div class="col-12 col-md-4">
    <h1>{{ "about_us" | translate }}</h1>
    <span
      >Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda
      molestiae eum voluptatum quae maiores minima quibusdam facilis. Nisi
      mollitia assumenda commodi iste error non repudiandae nemo corrupti
      cumque, quo, consequatur voluptates vitae amet laborum fugiat debitis
      quibusdam laboriosam a? Libero quidem vitae totam inventore ipsam est
      dolor iusto culpa qui.</span
    >
  </div>
  <div class="col-12 col-md-4 mt-5 mt-md-0">
    <h1>{{ "social_networks" | translate }}</h1>
    <div class="red">
      <i class="fab fa-facebook fa-2x"></i>
      <span>Facebook</span>
    </div>
    <div class="red">
      <i class="fab fa-instagram fa-2x"></i>
      <span>Instagram</span>
    </div>
    <div class="red">
      <!-- <i class="fab fa-twitter fa-2x"></i> -->
      <!-- <span>Twitter</span> -->
      <i>
        <img src="assets/images/sociales/xcom_cuadrado.png" 
          width="30" height="30"
        />
      </i>
      <span>X.com</span>

    </div>
    <div class="red">
      <i class="fab fa-youtube fa-2x"></i>
      <span>Youtube</span>
    </div>
  </div>
  <div class="col-12 col-md-4 mt-5 mt-md-0">
    <h1>{{ "mission" | translate }}</h1>
    <span
      >Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus
      voluptatem dicta provident ab, quisquam in enim cupiditate, architecto,
      eos explicabo pariatur blanditiis deleniti accusamus inventore. Officia
      dignissimos nesciunt ratione reprehenderit?</span
    >
    <h1 class="mt-3">{{ "vision" | translate }}</h1>
    <span
      >Lorem ipsum dolor sit, amet consectetur adipisicing elit. Qui adipisci
      impedit doloribus, sit libero ab quas quibusdam perspiciatis maiores
      voluptatum!</span
    >
    <h1></h1>
  </div>
</div>
